import { PlayerCluster } from './PlayerCluster';
import { TopRightHud } from './TopRightHud';
import { LocationPrompt } from './LocationPrompt';
import { FloorTransition } from './FloorTransition';
import { LevelUpFeed } from './LevelUpFeed';
import { useFloorTransitionStore } from '../../store/floorTransitionSlice';

export const DungeonScreen = () => {
  const transition = useFloorTransitionStore((s) => s.active);

  return (
    <>
      <PlayerCluster />
      <TopRightHud />
      <LevelUpFeed />
      <LocationPrompt />
      {transition && <FloorTransition />}
    </>
  );
};
